import { scheduleInputToInstant } from "@common/utils/adsetSchedule";
import { resolveEventWallTimezone } from "./eventWallMinuteStrings";

/** Event-wall `YYYY-MM-DDTHH:mm` (or wire ISO) → unix seconds in the event zone, or null. */
export function wallMinuteStringToUnixSeconds(
  wall: string,
  eventTimezone: string
): number | null {
  const inst = scheduleInputToInstant(
    wall.trim(),
    resolveEventWallTimezone(eventTimezone)
  );
  return inst ? inst.unix() : null;
}
